export default "__VITE_ASSET__ae8XltvV__"